import { Text } from '@a0/quantum-web';
import Image from 'next/image';
import * as S from './styled';
import dictionary from '../../../dictionary';
import { COMMUNITY } from '../../../constants';

const Community = () => (
  <S.Wrapper>
    {dictionary[COMMUNITY].map((menu, i) =>
      i === 0 ? (
        <S.DarkContainer key={menu.title}>
          <S.Title>{menu.title}</S.Title>
          <S.LinksWrapper>
            {menu.links.map((link) => (
              <S.DarkLink rel="external" key={link.title} href={link.url}>
                <Text
                  type="Paragraph"
                  size="xsmall"
                  styleOverrides={{
                    'text-decoration': 'none',
                    'font-weight': '500',
                  }}
                >
                  {link.title}
                </Text>
                <Text type="Paragraph" size="xsmall">
                  {link.description}
                </Text>
              </S.DarkLink>
            ))}
          </S.LinksWrapper>
        </S.DarkContainer>
      ) : (
        <S.GreyContainer key={menu.title}>
          <S.Title>{menu.title}</S.Title>
          <S.GreyLink rel="external" key={menu.eventName} href={menu.url}>
            <S.ImageWrapper>
              <Image
                src={menu.image}
                width={256}
                height={144}
                alt=""
              />
            </S.ImageWrapper>
            <Text
              type="Paragraph"
              size="xsmall"
              styleOverrides={{
                'text-decoration': 'none',
                'font-weight': '500',
              }}
            >
              {menu.eventName}
            </Text>
            <Text type="Paragraph" size="xsmall">
              {menu.description}
            </Text>
          </S.GreyLink>
        </S.GreyContainer>
      ),
    )}
  </S.Wrapper>
);

export default Community;
